import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import { USER_ROLES } from '../../constants';

interface RequirePremiumProps {
  children: React.ReactNode;
}

export function RequirePremium({ children }: RequirePremiumProps) {
  const { user, isLoading: authLoading } = useAuth();

  // Still loading
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-neutral-50 dark:bg-neutral-900">
        <div className="w-8 h-8 border-4 border-brand-500 dark:border-brand-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin bypass - always allow
  if (user.role === USER_ROLES.ADMIN) {
    return <>{children}</>;
  }

  // Check if user has premium subscription (check both subscription_status AND is_grandfathered for safety)
  const isPremium = user.subscription_status === 'active' || user.subscription_status === 'grandfathered' || user.is_grandfathered === true;

  if (!isPremium) {
    // Redirect to billing page where they can upgrade
    return <Navigate to="/billing" replace />;
  }

  // User has premium access, show protected content
  return <>{children}</>;
}
